import { Stats as a } from "@react-three/drei";
import { Canvas as s } from "@react-three/fiber";
import { NoToneMapping as d } from "three";
import { OrbitCtxProvider as f } from "../orbit-ctx/index.js";
import { jsx as r, jsxs as g, Fragment as i } from "react/jsx-runtime";
const C = ({
  children: e,
  lights: m = !0,
  style: p = {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  orbit: o,
  stats: t = !0,
  ...n
}) => /* @__PURE__ */ r("div", {
  style: p,
  children: /* @__PURE__ */ g(s, {
    frameloop: "demand",
    shadows: !0,
    gl: {
      toneMapping: d
    },
    ...n,
    children: [o && /* @__PURE__ */ r(f, {
      ...o === !0 ? {} : o,
      children: e
    }), !o && /* @__PURE__ */ r(i, {
      children: e
    }), m && /* @__PURE__ */ r(i, {
      children: /* @__PURE__ */ r("hemisphereLight", {
        args: [16777215, 4334080],
        position: [-1, 1.5, 1]
      })
    }), t && /* @__PURE__ */ r(a, {
      ...t === !0 ? {} : t
    })]
  })
});
export {
  C as CanvasFC
};
//# sourceMappingURL=index.js.map
